import Header from "./header"
import Hero from "./hero"
import About from "./about"
import MissionVision from "./missionVision"
import Services from "./services"
import WhyCircleConnect from "./whyCircleConnect"
import "./globals.css"
import Contact from "./contact"
export default function LandingPage() {
  return (
<div>
     <Header/>
      <Hero />
      <About />
      <MissionVision />
      <Services />
      <WhyCircleConnect />
      {/* <Contact /> */}
      {/* <Footer /> */}
    </div>
  )
}